import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import IconView from "../../FontIcons/IconView";
import Avatar from "@mui/material/Avatar";
import GetInstitutionsList from "./GetInstitutionsList";
import { DialogContent } from "@mui/material";


export default function SettingiewDialogue(props) {

  const [open, setOpen] = React.useState(false);
  const {usertoken} = props;
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); 
  };



  // Get List of Qualification from the server

  React.useEffect(() => {
   
  }, []);

  return (
    <div className="appicant-profile-dialog-con w-500rem ">
      <Button variant="contained" onClick={handleClickOpen}>
        <IconView
          tooltipText="View Applicants Profile"
          tooltipColor="white"
          tooltipIconSize="19px"
        />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{ "& .MuiDialog-paper": { width: "1000px", maxWidth: "1000px" } }}
      >
        <DialogContent>
          <GetInstitutionsList />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
